module.exports = __webpack_public_path__ + "9141ed94c6c20c1b6bc8156107bb80a9.jpg";